/** @jsxImportSource @emotion/react */

import { media } from '@stories/theming/settings';

import { colors, headlines, section } from './VitafyAboutUsPage';

type ItemProps = {
  headline: string;
  body: string;
  index?: number;
};

const Item: React.FC<ItemProps> = ({ body, headline, index }) => {
  return (
    <div
      css={{
        background: 'linear-gradient(#004D71 0%, #002739 100%)',
        padding: '4rem 1.5rem',
        color: 'white',
        overflow: 'hidden',
        position: 'relative',
        textAlign: 'center',
        '::after': {
          content: `"${index?.toString()}"`,
          display: 'block',
          fontSize: '360px',
          lineHeight: '.75',
          fontWeight: '900',
          position: 'absolute',
          top: '0',
          left: '-1rem',
          opacity: '.15'
        },
        [media('desktop')]: {
          flex: '1 0 32%'
        }
      }}
    >
      <h3 css={{ ...headlines.h4, lineHeight: '1.4' }}>{headline}</h3>
      <p css={{ color: '#F7FCFF', opacity: '0.8', lineHeight: '1.6', marginTop: '1.5rem' }}>{body}</p>
    </div>
  );
};

export type OverviewProps = {
  items: ItemProps[];
};

export const Overview: React.FC<OverviewProps> = ({ items }) => {
  return (
    <section css={{ ...section }}>
      <header css={{ textAlign: 'center' }}>
        <h2 css={headlines.h3}>Alles auf einen Blick</h2>
        <span css={{ color: colors.copy, display: 'block', marginTop: '2rem', fontWeight: '400' }}>
          Geprüfte Qualität, riesige Auswahl und Vertrauen für dein gesünderes Leben
        </span>
      </header>
      <div
        css={{
          display: 'flex',
          gap: '1rem',
          flexWrap: 'wrap',
          marginTop: '3rem',
          [media('desktop')]: { flexWrap: 'nowrap' }
        }}
      >
        {items.map((item, index) => (
          <Item key={item.headline} {...item} index={index + 1} />
        ))}
      </div>
    </section>
  );
};
